import React from "react";
import { useNavigate } from "react-router-dom";

import shirts from "../assets/shirts.png";
import pants from "../assets/pants.png";
import blouse from "../assets/blouse.png";
import kurta from "../assets/kurthi.png";

export default function DressComponent() {
  const navigate = useNavigate();

  const dressImages = {
    Shirt: shirts,
    Pant: pants,
    Blouse: blouse,
    Kurta: kurta
  };

  return (
    
      

      <div className="max-w-4xl mx-auto p-6">
      
        <div className="mb-6">
          <button
            onClick={() => navigate('/InsertFittings')}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-4 px-6 rounded-lg shadow-lg transition-all flex items-center justify-center gap-2"
          >
            <span className="text-2xl">+</span>
            <span>Add New Fitting</span>
          </button>
        </div>

        
        <div className="grid grid-cols-2 gap-4">
          {Object.keys(dressImages).map((dress) => (
            <div
              key={dress}
              onClick={() => navigate(`/fit-details/${dress}`)}
              className="bg-white rounded-xl p-4 shadow cursor-pointer hover:scale-[1.02] transition flex flex-col items-center"
            >
              <img
                src={dressImages[dress]}
                alt={dress}
                className="w-24 h-24 object-contain mb-2"
              />
              <p className="text-gray-800 font-medium">{dress}</p>
            </div>
          ))}
        </div>
      </div>
    
  );
}
